import gql from "graphql-tag";

export const ACTIVATE_ACCOUNT = gql`
    mutation ActivateAccount($uid: String!, $token: String!) {
        activateAccount (input: {
            uid: $uid,
            token: $token
        }){
            user{
                email
                isActive
            }
        }
    }
`;
